import { MONTHS } from 'constant'

/**
 * Function receives sequence number of month and returns month name
 * @param number
 * @returns {string|undefined}
 */
export const getMonthNameBySequenceNumber = number =>
  MONTHS[parseInt(number, 10) - 1]
